import React from 'react';
import { ChevronDown } from 'lucide-react';

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options: Array<{ value: string | number; label: string }>;
}

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ label, error, options, className = '', required, ...props }, ref) => {
    return (
      <div className="w-full">
        {label && (
          <label className="block text-xs sm:text-sm font-medium text-neutral-700 mb-1.5">
            {label}
            {required && <span className="text-error-500 ml-1">*</span>}
          </label>
        )}
        <div className="relative">
          <select
            ref={ref}
            className={`w-full px-3 sm:px-4 py-2.5 sm:py-3 bg-white border rounded-xl shadow-sm transition-all duration-200 
            text-sm sm:text-base text-neutral-800 appearance-none cursor-pointer
            focus:outline-none focus:ring-2 focus:ring-offset-0 focus:border-transparent
            disabled:bg-neutral-50 disabled:cursor-not-allowed disabled:text-neutral-400 ${
              error 
                ? 'border-error-300 focus:ring-error-500/30 bg-error-50/30' 
                : 'border-neutral-200 focus:ring-primary-500/30 hover:border-neutral-300'
            } ${className}`}
            {...props}
          >
            {options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 sm:w-5 sm:h-5 text-neutral-400 pointer-events-none" />
        </div>
        {error && <p className="mt-1.5 text-xs sm:text-sm text-error-500">{error}</p>}
      </div>
    );
  }
);

Select.displayName = 'Select';
